import React from "react";
import { useAppDispatch, useAppSelector } from "../../../../app/store";
import {
    changeCollectionModal,
    deleteCollectionElement,
    deleteCollectionRow,
    saveCollectionSlideRows,
} from "../../../../app/slices/modals/collectionEditModal";
import { openModal } from "../../../../app/slices/modals/collectionElementModal";
import { GridRow } from "../../../../types/admin";
import SlideEditorBase from "../shared/SlideEditor";

const CollectionSlideEditor = () => {
    const dispatch = useAppDispatch();
    const { slide_rows, slide_id, languageTab } = useAppSelector((state) => state.collectionEditModal);

    const handleChangeRows = (rows: GridRow[]) => {
        if (!slide_id) {
            return;
        }
        dispatch(changeCollectionModal({ slide_rows: rows }));
        dispatch(saveCollectionSlideRows({ slide_id, slide_rows: rows }));
    };

    const handleDeleteRow = (rowId: string) => {
        if (rowId && slide_id) {
            dispatch(deleteCollectionRow({ slide_id, row_id: rowId }));
        }
    };

    const handleDeleteElement = (elementId: string) => {
        if (elementId && slide_id) {
            dispatch(deleteCollectionElement({ slide_id, element_id: elementId }));
        }
    };

    return (
        <SlideEditorBase
            slideRows={slide_rows}
            languageTab={languageTab}
            onChangeRows={handleChangeRows}
            onDeleteRow={handleDeleteRow}
            onDeleteElement={handleDeleteElement}
            onOpenElementModal={(payload) => dispatch(openModal(payload))}
        />
    );
};

export default CollectionSlideEditor;
